<div class="min-h-screen">
    <core-banner></core-banner>
    <core-user-navbar></core-user-navbar>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <core-user-footer></core-user-footer>
</div>